import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { fetchConstituencies, deleteConstituency } from '../../utils/api';
import MasterDataTable from '../../components/MasterDataTable';

const columns = [
  { id: 'constituencyId', label: 'ID', minWidth: 50 },
  { id: 'lokSabhaConstituency', label: 'Lok Sabha', minWidth: 150 },
  { id: 'rajyaSabhaConstituency', label: 'Rajya Sabha', minWidth: 150 },
  { id: 'vidhanSabhaConstituency', label: 'Vidhan Sabha', minWidth: 150 },
  { id: 'pinCode', label: 'PIN Code', minWidth: 100 },
];

const ConstituencyList = ({ onEdit, searchQuery = '' }) => {
  const [constituencies, setConstituencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const loadConstituencies = async () => {
      setLoading(true);
      try {
        const response = await fetchConstituencies();
        if (cancelled) return;
        setConstituencies(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching constituencies:', err);
        if (!cancelled) {
          setError('Failed to load constituencies. Please try again later.');
          setConstituencies([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadConstituencies();
    return () => {
      cancelled = true;
    };
  }, [refreshTrigger]);

  const handleDelete = async (constituency) => {
    try {
      await deleteConstituency(constituency.constituencyId, {
        previousData: constituency,
        identifier: constituency.lokSabhaConstituency
      });
      setRefreshTrigger(prev => prev + 1);
    } catch (err) {
      console.error('Error deleting constituency:', err);
      alert('Failed to delete constituency. It may be referenced by other records.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Constituencies
      </Typography>
      
      <MasterDataTable
        persistKey="constituency"
        data={constituencies}
        columns={columns}
        isLoading={loading}
        searchQuery={searchQuery}
        onEdit={onEdit}
        onDelete={handleDelete}
        emptyMessage="No constituencies found. Add your first constituency!"
      />
      
      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default ConstituencyList;

